module.exports = __webpack_public_path__ + "assets/security.60bed19e.svg";